type Closer = () => void;

const stack: Closer[] = [];

export function pushDropdownCloser(close: Closer): () => void {
    stack.push(close);
    return () => {
        const index = stack.lastIndexOf(close);
        if (index >= 0) {
            stack.splice(index, 1);
        }
    };
}

/** Close the top open dropdown. Returns true if a dropdown consumed Escape. */
export function closeTopDropdown(): boolean {
    if (stack.length === 0) {
        return false;
    }
    const close = stack[stack.length - 1];
    close();
    return true;
}
